<form [formGroup]="form">
  <article class="flex items-center mb-20">
    <span class="title-1 font-normal">Managed Repair Sites</span>
  </article>

  @if (selectedRepairerSites().length) {
    <article class="grid grid-cols-4 gap-15 px-5">
      @for (site of selectedRepairerSites(); track site) {
        <mat-checkbox
          class="charcoal-checkbox"
          [checked]="repairerSites.value.includes(site.id)"
          (change)="onCheckRepairerSiteCheckbox($event.checked, site.id)">
          {{ site.companyName }}
        </mat-checkbox>
      }
    </article>
  } @else {
    <infos-guidance [guidanceTemplate]="noSiteGuidance" />
  }

  <mat-divider class="my-20!" />

  <article class="flex items-center mb-20">
    <span class="title-1 font-normal">All Repair Sites</span>

    <mat-checkbox
      class="ml-15 mr-50"
      [disabled]="mladminService.notArchivedRepairerSitesList().length === 0"
      [checked]="selectAll"
      (change)="selectAllVisibleRepairerSites($event.checked)">
      Select All
    </mat-checkbox>

    <div class="flex flex-grow">
      <mat-form-field class="w-[180px]! remove-end-border-radius no-validation">
        <mat-select formControlName="searchRepairerGroup" (selectionChange)="getRepairerSites()">
          @for (group of repairerGroupList(); track group) {
            <mat-option [value]="group">{{ group }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field class="input-search subtitle-2 remove-start-border-radius no-validation">
        <input formControlName="search" matInput placeholder="Type to search" />
      </mat-form-field>
    </div>
    <button matButton="elevated" class="red-button max-h-35 w-[110px]" (click)="getRepairerSites()">SEARCH</button>
  </article>

  @if (mladminService.loadingNotArchivedRepairerSitesList()) {
    <article class="w-full flex justify-center items-center p-y-20 mb-15">
      <mat-spinner diameter="20" class="mr-10" />
      <span class="text-red">Loading...</span>
    </article>
  }

  @if (
    searchPerformed &&
    !mladminService.loadingNotArchivedRepairerSitesList() &&
    !mladminService.notArchivedRepairerSitesList().length
  ) {
    <article class="w-full flex justify-center items-center p-y-20 mb-15">
      <mat-icon class="size-18! text-18! mr-5 text-red!">report_problem</mat-icon>
      <span class="body-1 text-red">No results could be found. Please review your search.</span>
    </article>
  }

  @if (!mladminService.loadingNotArchivedRepairerSitesList() && mladminService.notArchivedRepairerSitesList().length) {
    <article>
      @if (
        mladminService.notArchivedRepairerSitesTotalNumberOfMatchesFound() >
        mladminService.notArchivedRepairerSitesList()?.length
      ) {
        <div class="w-full flex justify-center items-center pb-20">
          <mat-icon class="mr-5">info_outline_24px</mat-icon>
          <span class="body-1">
            Showing {{ mladminService.notArchivedRepairerSitesList()?.length }} results out of
            {{ mladminService.notArchivedRepairerSitesTotalNumberOfMatchesFound() }}. Please refine your search.
          </span>
        </div>
      }
      <div class="max-h-[130px] grid grid-cols-4 gap-15 mb-10 px-5">
        @for (site of mladminService.notArchivedRepairerSitesList(); track site) {
          <mat-checkbox
            class="charcoal-checkbox"
            [checked]="repairerSites.value.includes(site.id)"
            (change)="onCheckRepairerSiteCheckbox($event.checked, site.id)">
            {{ site.companyName }}
          </mat-checkbox>
        }
      </div>
    </article>
  }
</form>

<ng-template #noSiteGuidance>
  <span class="body-1">
    This administrator does not currently manage any repairer sites. Use the search below to add their managed sites.
  </span>
</ng-template>
